module.exports = ".edit-unauthorized {\n  width: 100%;\n  max-width: 800px;\n  margin: 86px auto;\n  padding: 0 50px;\n}\n@media (min-width: 700px) {\n  .edit-unauthorized {\n    padding: 0 180px 0 0;\n  }\n}\n.edit-unauthorized .sg-btn {\n  margin: 25px 2px 2px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/unauthorized.less
// module id = ./src/app/unauthorized/unauthorized.less
// module chunks = main